import React, { useEffect, useRef, useState } from 'react'
import Fade from 'react-reveal/Fade'
import { Link } from 'gatsby'
import Modal from '@mui/material/Modal'
import Box from '@mui/material/Box'
import CloseIcon from '@mui/icons-material/Close'

import { landingImages } from '../mock'

import './styles/Landing.css'

const Landing = () => {
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    boxShadow: 24,
    pt: 2,
    position: 'relative',
    px: 4,
    pb: 3,
    outline: 0,
  }
  const renderCount = useRef(0)
  const [open, setOpen] = useState(null)

  useEffect(() => {
    if (sessionStorage.getItem('isPopupShown') !== 'shown') {
      setOpen(true)
      sessionStorage.setItem('isPopupShown', 'shown')
    } else {
      setOpen(false)
    }
  }, [])

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <div className="landing-page">
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box sx={{ ...style, width: 200 }}>
          <CloseIcon
            onClick={() => {
              handleClose()
            }}
            style={{ position: 'absolute', right: '20px', cursor: 'pointer' }}
          />
          <h2 id="child-modal-title" style={{ color: 'red' }}>
            DISCLAIMER!!!!
          </h2>
          <p id="child-modal-description">
            PLEASE READ BEFORE MOVING FORWARD!!!! THIS WEBSITE IS NOT AN
            OFFICIAL NINTENDO WEBSITE AND IS NO WAY AFFILIATED OR ENDORSED BY
            NINTENDO.
          </p>
        </Box>
      </Modal>

      <div style={{ position: 'relative' }}>
        <Fade top>
          <h1 className="landing-page__title">
            Welcome to <span className="landing-page__nintendo">N</span>I Store!
          </h1>
        </Fade>
        <Fade bottom>
          <p className="landing-page__subtitle">
            India's best Nintendo Switch Games Reseller
          </p>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: '40px',
            }}
          >
            <Link className="landing-page__button" to="/games/">
              Browse Games
            </Link>
            <Link className="landing-page__button" to="/consoles/">
              Browse Consoles
            </Link>
          </div>
        </Fade>
        <Fade top>
          {landingImages.map((image, index) => {
            return (
              <img
                key={index}
                className={`landing-image ${image.class}`}
                src={image?.url}
                alt={image.class}
              />
            )
          })}
        </Fade>
      </div>
    </div>
  )
}

export default Landing
